import { z } from 'zod/v4';

export const VectorSearchQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(1).max(500).default(15),
  searchQuery: z.string().min(1).max(255),
  excludeCompanyIds: z.string().min(1).nullable().optional(),
});

export type VectorSearchQuery = z.infer<typeof VectorSearchQuerySchema>;

export const PaginatedMetaSchema = z.object({
  count: z.number(),
  page: z.number(),
  totalCount: z.number(),
  pageSize: z.number(),
});

export type PaginatedMeta = z.infer<typeof PaginatedMetaSchema>;

export const VectorSearchResultSchema = z
  .object({
    id: z.string(),
    key: z.string(),
    byCompanyId: z.string(),
    companyId: z.string(),
    vectorDistance: z.number(),
    officialName: z.string().nullable(),
    name: z.string().nullable(),
    displayName: z.string().nullable(),
    country: z.string().nullable(),
    countryName: z.string().nullable(),
    facilityProcesses: z.string().nullable(),
    connectionTypeId: z.string().nullable(),
    imageList: z.array(z.unknown()),
    featuredImageFileUrl: z.string().nullable(),
    originalFeaturedImageFileUrl: z.string().nullable(),
    originalVideoFileUrl: z.string().nullable(),
    supplyChainTier: z.array(z.unknown()),
    relationshipType: z.array(z.unknown()),
    responsiblePerson: z.array(z.unknown()),
  })
  .passthrough();

export type VectorSearchResult = z.infer<typeof VectorSearchResultSchema>;

export const VectorSearchResponseSchema = z.object({
  data: z.array(VectorSearchResultSchema),
  meta: PaginatedMetaSchema,
});

export type VectorSearchResponse = z.infer<typeof VectorSearchResponseSchema>;
